import React, { Component }       from 'react';
import { withRouter }             from 'react-router'
import { connect }                from 'react-redux';
import { bindActionCreators }     from 'redux';
import { logout }                 from '../../redux/actions/user';
import { Route, Switch }          from 'react-router-dom'
import PropTypes from 'prop-types';

import Modal from '../../components/Modal';


import { userIsAdmin } from '../../auth.js'

/**
 * Pages
 */
import Main                       from '../../pages/Dashboard/Main';
import AddUser                    from '../../pages/Dashboard/AddUser';
import ListUsers                  from '../../pages/Dashboard/ListUsers';
import EditUser                   from '../../pages/Dashboard/EditUser';
import AddMember                  from '../../pages/Dashboard/AddMember';
import SearchMember               from '../../pages/Dashboard/SearchMember';
import EditMember                 from '../../pages/Dashboard/EditMember';
import EnrollMember               from '../../pages/Dashboard/EnrollMember';
import EnrollmentConfirmation     from '../../pages/Dashboard/EnrollmentConfirmation';
import IdleTimer                  from '../../components/IdleTimer'

/**
 * Componenets
 */
import Navbar                     from '../../components/Navbar';

class Dashboard extends Component {

  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      modalChildren: '',
			modalConfig: {}
    };
  }


  closeModal() {
    this.setState({
      modalComponent: '',
      modalOptions: {},
      showModal: false
    });
  }

  handleShowModal(showModal = false, children, modalConfig = {}) {
    let modalChildren = typeof children !== 'undefined' ? children : '';

    this.setState({
      showModal,
			modalConfig,
      modalChildren
    });
  }

  getChildContext() {
    return {
			showModal: this.handleShowModal.bind(this)
		};
  }


  render() {
    return (
      <IdleTimer>
        <div className="dashboard">
          <Navbar {...this.props}/>
          <Switch>
            <Route exact path='/dashboard' component={Main} />
            <Route exact path='/dashboard/add-user' component={AddUser} />
            <Route exact path='/dashboard/edit-user/:id' component={userIsAdmin(EditUser)} />
            <Route exact path='/dashboard/list-users' component={userIsAdmin(ListUsers)} />
            <Route exact path='/dashboard/add-member' component={AddMember} />
            <Route exact path='/dashboard/edit-member/:id' component={EditMember} />
            <Route exact path='/dashboard/enroll-member/:id' component={EnrollMember} />
            <Route exact path='/dashboard/enroll-confirmation/:id' component={EnrollmentConfirmation} />
            <Route exact path='/dashboard/search-member' component={SearchMember} />
          </Switch>
          {
            this.state.showModal ?
              <Modal config={this.state.modalConfig}>
                {this.state.modalChildren}
              </Modal>
              : ''
          }
        </div>
      </IdleTimer>
    );
  }
}


Dashboard.childContextTypes = {
  showModal:   PropTypes.func,
  closeModal:  PropTypes.func
};

function mapStateToProps(state) {
  return {
    user: state.user
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    logout
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Dashboard));



// WEBPACK FOOTER //
// ./src/containers/Dashboard/Dashboard.js